




























































































import { Component, Vue, Watch } from "vue-property-decorator";
import * as savePasswordApi from "@/services/user/index";
import { GenericMessage } from "@/api/user/types";

@Component({
  name: "ChangePasswordForm",
})
export default class ChangePasswordForm extends Vue {
  private oldPassword: string = "";
  private password: string = "";
  private confirmPassword: string = "";
  private passwordLength: boolean | null = null;
  private passwordMacth: boolean | null = null;
  private isLoading: boolean | null = null;
  private isSuccess: boolean | null = null;
  private response: string | undefined = "";

  @Watch("response", { immediate: true })
  private onResponseChange() {
    if (this.response !== undefined && this.response !== "") {
      setTimeout(() => {
        this.$router.push("/me");
      }, 10000);
    }
  }

  get userEmail() {
    return this.$store.state.user.email;
  }

  private hasMinMaxLength() {
    if (this.password.length >= 8) {
      this.passwordLength = false;
      return;
    }
    this.passwordLength = true;
    return;
  }

  private matchPasswords() {
    if (this.confirmPassword === this.password) {
      this.passwordMacth = false;
      return;
    }
    this.passwordMacth = true;
    return;
  }

  private async savePassword() {
    this.isLoading = true;
    const oldPassword = this.oldPassword;
    const password = this.password;
    const email = this.userEmail;

    try {
      this.response = await savePasswordApi.changePassword({
        oldPassword,
        password,
        email,
      });
      this.oldPassword = "";
      this.password = "";
      this.confirmPassword = "";
    } catch (e) {
    } finally {
      this.isLoading = false;
    }
  }
}
